
import AdvancedPayment from "../components/business/AdvancedPayment";
import CardProcessing from "../components/business/CardProcessing";
import IntegrationOptions from "../components/business/IntegrationOptions";
import HeadingWithChips from "../components/common/HeadingWithChips";
import HowToGetStarted from "../components/common/HowToGetStarted";
import { BusinessContactForm } from "../components/common/ReusableContactForm";
import Footer from "../components/Footer";
import background from '../assets/available/background.png';
import FirstSection from "../components/common/FirstSection";
import amazingicon from '../assets/available/amazingicon.png';
import firstbackground from '../assets/available/background.png'
const Business: React.FC = () => {
  const businessSteps = [
    {
      number: "1",
      title: "Register\nas an Individual",
      description:
        "Begin by creating an account \n through our easy-to-use \n platform",
    },
    {
      number: "2",
      title: "Switch to\na Business Account",
      description:
        "Once registered, upgrade to\n a business account directly\non the platform.",
    },
    {
      number: "3",
      title: "Onboard\nwith Experts",
      description:
        "Work with the professional EPAYR\n team to tailor the process\nto your needs.",
    },
  ];
    return (
          <main>
            <FirstSection 
              icon={amazingicon}
              iconAlt="Suite icon"
              backgroundImage={firstbackground}
              title="Available in <br/>
                80+ countries, <br/>
                supporting <br/>
                40+ currencies"
              titleColor="beige.100"
              description={
                  <>
                      EPAYR simplifies complex payment <br/>
                processes, giving your business <br/>
                the tools to grow globally with ease
                  </>
              }
              descriptionColor="beige.100"
              buttonText="CONTACT US"
              buttonHref="/contact?type=company"
              buttonVariant="lightPurple"
              leftColumnSx={{
                  backgroundColor: "darkPurple.500"
              }}
              heading="comprehensive <br/> solutions for <br/>
                    your business"
              headingColor="darkPurple.500"
              />
                  <CardProcessing/>
            <AdvancedPayment/>
            <IntegrationOptions/>
            <HowToGetStarted steps={businessSteps}/>
            <HeadingWithChips 
              headingPrefix="The verification is done"
              headingHighlight=" remotely"
              headingSuffix=""
              subheading=''
              discussionText={["YOU CAN OPEN AN ", "<br/>FROM ", "IN THE WORLD"]}
              chips = {[
                { text: "ACCOUNT",  backgroundColor: "beige.200",  textColor: "beige.700" },
                { text: "ANYWHERE", backgroundColor: "lightPurple.200", textColor: "lightPurple.500" },
                
              ]}
              displayIcons={true}
            />
            <BusinessContactForm background={background} />
            <Footer 
              buttonText="CONTACT US" 
              buttonLink="/contact?type=company"
              ctaText={{
                prefix: 'REQUEST A',
                highlight1: '  PERSONALIZED QUOTE ',
                middle: ' BASED ON YOUR BUSINESS SIZE AND UNIQUE GOALS',
                highlight2: '',
                suffix: ''
              }}
            />
          </main>
    );
  };
  
  export default Business;
  